import type { ListRequestCommon } from '@/models/api/list-request-common'
import type { News } from '@/models/api/news'
import { newsSchema } from '@/models/api/news'
import {
  apiValidator,
  type ApiFactory,
  type ApiRequestConfig,
  type ApiResponse
} from '~library/services'

export default class NewsApi {
  constructor(private api: ApiFactory) {}

  /**
   * API 取得最新消息明細
   * https://hackmd.io/Me823ObzR36yQFl1FH9eYA
   */
  @apiValidator(newsSchema)
  getData(id: string, config?: ApiRequestConfig): Promise<ApiResponse<News>> {
    return this.api.get(`News/News/${id}`, config)
  }

  /**
   * API 取得最新消息清單
   * https://hackmd.io/F08y8-WMSVmBNp5QWaxrOg
   */
  @apiValidator(newsSchema.array())
  getList(
    query: ListRequestCommon,
    config?: ApiRequestConfig
  ): Promise<ApiResponse<News[]>> {
    return this.api.post('News/GetList', query, config)
  }

  /**
   * API 取得異業合作清單
   * https://hackmd.io/9RAo3DPwSimA64SY0CtYbA
   */
  @apiValidator(newsSchema.array())
  getJointPromotionList(
    query: ListRequestCommon,
    config?: ApiRequestConfig
  ): Promise<ApiResponse<News[]>> {
    return this.api.post('News/GetJointPromotionList', query, config)
  }

  /**
   * API 取得異業合作單筆資料
   * https://hackmd.io/YbBwewDJQZOnUbT7V5h45Q
   */
  @apiValidator(newsSchema)
  getJointPromotionDetail(
    id: string,
    config?: ApiRequestConfig
  ): Promise<ApiResponse<News>> {
    return this.api.get(`News/GetJointPromotionDetail/${id}`, config)
  }

  /**
   * API 取得獨享清單
   * https://hackmd.io/RwPBmlnASfOWLIlNDEAfAw
   */
  @apiValidator(newsSchema.array())
  getExclusiveList(
    query: ListRequestCommon,
    config?: ApiRequestConfig
  ): Promise<ApiResponse<News[]>> {
    return this.api.post('News/GetExclusiveList', query, config)
  }

  /**
   * API 取得獨享單筆資料
   * https://hackmd.io/M95Rr6gVSWWFaMnRaRgmWg
   */
  @apiValidator(newsSchema)
  getExclusiveDetail(
    id: string,
    config?: ApiRequestConfig
  ): Promise<ApiResponse<News>> {
    return this.api.get(`News/GetExclusiveDetail/${id}`, config)
  }
}
